import defaultTheme from '../theme/default.useable.less'
import redTheme from '../theme/red.useable.less'
import orangeTheme from '../theme/orange.useable.less'

let lastTheme = null

export default (type) => {

  const themes = {
    defaultTheme,
    redTheme,
    orangeTheme,
  }
  lastTheme && lastTheme.unuse()
  lastTheme = themes[`${type}Theme`]
  lastTheme.use()
}
